function sortOrganizations(organizations, lang) {
  if (!organizations) {
    return [];
  }
  let out = Object.values(organizations);
  if (out.length === 0) return [];
  let loc_name = lang ? `name_${lang}` : "name";
  out.forEach((item) => {
    if (item[loc_name]) {
      item.name = item[loc_name]; // name based on current locale
    } else if (item.name) {
      // item.name should be default language
    } else {
      // other language mutations
      let available = Object.entries(item)
        .filter(([key, value]) => key.startsWith("name_") && !!value)
        .map(([, value]) => value);
      if (available.length > 0) {
        item.name = available[0];
      } else if (item.internal_id) {
        item.name = item.internal_id; // internal_id fallback
      } else if (item.short_name) {
        item.name = item.short_name; // short_name fallback
      } else {
        item.name = "-";
      }
    }
  });
  out.sort((a, b) => {
    if ("extra" in a) {
      return -1;
    }
    if ("extra" in b) {
      return 1;
    }
    return a["name"].localeCompare(b["name"]);
  });
  return out;
}

// Builds a Vuetify `custom-filter` that matches every whitespace-separated
// query word against the item's title (`titleKey`) and its `short_name`.
// `titleKey` lets callers pick the field holding the display text (e.g. "name"
// for organizations, "text" for translated dimension values).
function makeNameShortNameFilter(titleKey = "name") {
  return function (value, query, item) {
    const raw = item?.raw ?? item;

    if (!raw) {
      return false;
    }

    const searchText = `${raw[titleKey] ?? ""} ${
      raw.short_name ?? ""
    }`.toLowerCase();

    return (query ?? "")
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean)
      .every((word) => searchText.includes(word));
  };
}

const organizationFilter = makeNameShortNameFilter("name");

export { makeNameShortNameFilter, organizationFilter, sortOrganizations };
